// These Error Codes are handled for these Apis
// loan-validation-request
// direct-loan-request
// delete-loan-request/loan-request/guid
// send-transaction-otp-code
// sign-loan-contract

export enum ErrorCode {
  ACTIVE_LOAN_REQUEST_ERROR = 'ACTIVE_LOAN_REQUEST_ERROR',
  ACTIVE_VALIDATION_ERROR = 'ACTIVE_VALIDATION_ERROR',
  CANNOT_DELETE_LOAN_REQUEST = 'CANNOT_DELETE_LOAN_REQUEST',
  DUPLICATED_NATIONAL_CODE_ERROR = 'DUPLICATED_NATIONAL_CODE_ERROR',
  PAYMENT_REQUIRED = 'PAYMENT_REQUIRED',
  LOAN_REQUEST_GUID_REQUIRED = 'LOAN_REQUEST_GUID_REQUIRED',
  UNSUPPORTED_COUNTRY = 'UNSUPPORTED_COUNTRY',
  SERVICE_UNAVAILABLE = 'SERVICE_UNAVAILABLE',
  INVALID_FORM = 'INVALID_FORM',
  STATUS_CHANGE_FORBIDDEN = 'STATUS_CHANGE_FORBIDDEN',
  REPEAT_VALIDATION_STATUS_ERROR = 'REPEAT_VALIDATION_STATUS_ERROR',
  LOAN_TYPE_CHANGE_FORBIDDEN = 'LOAN_TYPE_CHANGE_FORBIDDEN',
  CELLPHONE_NUMBER_REQUIRED = 'CELLPHONE_NUMBER_REQUIRED',
  NAME_REQUIRED = 'NAME_REQUIRED',
  NATIONAL_CODE_REQUIRED = 'NATIONAL_CODE_REQUIRED',
  VALIDATION_REQUEST_ERROR = 'VALIDATION_REQUEST_ERROR',
  'PAID_VALIDATION_REQUEST' = 'PAID_VALIDATION_REQUEST',
}

const ERROR_CODE_FA: Record<ErrorCode, string> = {
  [ErrorCode.ACTIVE_LOAN_REQUEST_ERROR]: 'شما یک درخواست وام فعال دارید',

  [ErrorCode.ACTIVE_VALIDATION_ERROR]:
    'اعتبارسنجی مزرعه هر سه روز یک بار امکان پذیر است. لطفا بعدا تلاش کنید.',

  [ErrorCode.DUPLICATED_NATIONAL_CODE_ERROR]:
    'کد ملی وارد شده تکراری است. هر کد ملی تنها با یک شماره احراز هویت میشود.',

  [ErrorCode.CANNOT_DELETE_LOAN_REQUEST]: 'امکان حذف درخواست وام وجود ندارد',

  [ErrorCode.PAYMENT_REQUIRED]: 'پرداخت مورد نیاز است',

  [ErrorCode.LOAN_REQUEST_GUID_REQUIRED]: 'شناسه درخواست وام الزامی است',

  [ErrorCode.UNSUPPORTED_COUNTRY]: 'کشور پشتیبانی نمی‌شود',

  [ErrorCode.SERVICE_UNAVAILABLE]: 'سرویس در دسترس نیست',

  [ErrorCode.INVALID_FORM]: 'فرم نامعتبر است',

  [ErrorCode.STATUS_CHANGE_FORBIDDEN]: 'تغییر وضعیت مجاز نیست',

  [ErrorCode.REPEAT_VALIDATION_STATUS_ERROR]:
    'امکان اعتبارسنجی مجدد در این مرحله امکان پذیر نمی باشد.',

  [ErrorCode.LOAN_TYPE_CHANGE_FORBIDDEN]: 'تغییر نوع وام مجاز نیست',

  [ErrorCode.CELLPHONE_NUMBER_REQUIRED]: 'شماره موبایل الزامی است',

  [ErrorCode.NAME_REQUIRED]: 'نام الزامی است',

  [ErrorCode.NATIONAL_CODE_REQUIRED]: 'کد ملی الزامی است',

  [ErrorCode.VALIDATION_REQUEST_ERROR]: 'خطا در درخواست اعتبارسنجی',

  [ErrorCode.PAID_VALIDATION_REQUEST]: 'درخواست اعتبارسنجی وجود ندارد',
};

export const getPersianErrorCode = (code?: string | null): string => {
  if (!code) {
    return 'خطایی رخ داده است';
  }

  if (code in ERROR_CODE_FA) {
    return ERROR_CODE_FA[code as ErrorCode];
  }

  return 'خطای ناشناخته';
};
